/* eslint-disable ember/no-classic-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';

@tagName('')
export default class FilterInput extends Component {
  @tracked
  filterValue = '';
  trackValue = true;
  label = '';
  placeholder = '';

  @action
  setFilter(newValue) {
    if (this.trackValue) {
      this.filterValue = newValue;
    }
    if (!isEmpty(this.onChange)) {
      this.onChange(newValue);
    }
  }
}
